import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IamHeaderService {

  getDeviceContext(): string {

    const deviceContext = {
      device_id: localStorage.getItem('device_id') ?? crypto.randomUUID(),
      device_type: 'web',
      device_model: 'Chrome Browser',
      os_info: 'macOS 14',
      app_version: '1.0.0',
      timestamp: Math.floor(Date.now() / 1000)
  };   
    localStorage.setItem('device_id', deviceContext.device_id);
    return JSON.stringify(deviceContext);
  }

  generateNonce(): string {
    return btoa(crypto.randomUUID());
  }

  generateIdempotencyKey(): string {
    return crypto.randomUUID();
  }

  createPublicHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'x-device-context': this.getDeviceContext(),
      'x-req-nonce': this.generateNonce(),
      'x-tenant-id': environment.iam.tenantId,
      'idempotency-key': this.generateIdempotencyKey(),
    });
  }
}
